const DESKTOP_WIDTH = 1000;
const TABLET_WIDTH = 769;
const MOBILE_WIDTH = 620;

let resizeTimeout = null;
let windowWidth = window.innerWidth;
let windowHeight = window.innerHeight;
const slideOptions = {
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    touchMove: false,
    adaptiveHeight: true,
    variableWidth: true,
    responsive: [
        {
            breakpoint: DESKTOP_WIDTH,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: TABLET_WIDTH,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            }
        },
        {
            breakpoint: MOBILE_WIDTH,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
};


function windowResizeHandlerX(width) {
}
function windowResizeHandlerY(height) {
}
function windowResizeHandler() {
    const currentWidth = window.innerWidth;
    const currentHeight = window.innerHeight;
    clearTimeout(resizeTimeout);
    if (windowWidth !== currentWidth) {
        windowWidth = currentWidth;
        resizeTimeout = setTimeout(() => windowResizeHandlerX(currentWidth), 100);
    }
    if (windowHeight !== currentHeight) {
        windowHeight = currentHeight;
        resizeTimeout = setTimeout(() => windowResizeHandlerY(currentHeight), 100);
    }
}
window.addEventListener('resize', windowResizeHandler);

function animateValue(obj, start, end, duration, isFloat = false, hundred = false) {
    let startTimestamp = null;
    const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        if (isFloat) {
            const precision = hundred ? 100 : 10;
            obj.innerHTML = Math.floor((progress * (end - start) + start) * precision) / precision;
        } else {
            obj.innerHTML = Math.floor(progress * (end - start) + start);
        }
        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    };
    window.requestAnimationFrame(step);
}

//Slider
$(document).ready(function() {
    $('.slider-wrap').slick(slideOptions);
    // quiz
    $('#hva306 .quiz .qbtn').on('click', function() {
        var activeEl = $(this).closest('.quiz').find('.item.active');
        if (activeEl.length > 0) {
            close(activeEl);
        }
        $(this).closest('.quiz').find('.item.' + $(this).attr('data-val')).addClass('active');

        if ($(this).attr('data-val') === 'qst-f') {
            $('#hva306 .quiz').height($('#hva306 .quiz .item.final').height());
        }
    });

    // The following 2 lines are here to quickly switch to the final slide
    // $('#hva306 .quiz').find('.item').removeClass('active');
    // $('#hva306 .quiz').find('.item.qst-f').addClass('active');

    function debounce(func, timeout = 300){
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
    }

    var windowWidth = $(window).width();
    $(window).on('load resize', debounce(function () {
        var $closingItem = $('#hva306 .quiz .item.closing');
        if ($closingItem.length) {
            return;
        }
        var newWindowWidth = $(window).width();
        if (windowWidth === newWindowWidth) {
            return;
        }
        windowWidth = newWindowWidth;
        var $activeItem = $('#hva306 .quiz .item.active');
        if ($activeItem.length) {
            var $quizHeight = windowWidth < 768 && !$activeItem.hasClass('final') ? 640 : $activeItem.height();
            $('#hva306 .quiz').height($quizHeight);
        }
    }, 2000));

    function close(el) {
        el.addClass('closing');
        el.removeClass('active');
        setTimeout(function() {
            $('#hva306 .quiz .item').removeClass('closing');
        }, 700);
    }


    window.addEventListener('scroll', function() {
        let element = document.querySelector('.vertical-charts-wrp');;
        let position = element.getBoundingClientRect();

        if(position.top >= 0 && position.bottom <= window.innerHeight && !element.classList.contains('vch-bar-chart')) {

            const vchBarPercent = document.querySelectorAll('.vch-bar-percent');

            for(let i = 0; i < vchBarPercent.length; i++) {
                let percent = vchBarPercent[i].getAttribute('data-percent');
                let progress = vchBarPercent[i].nextElementSibling;
                let progressSib = vchBarPercent[i].nextElementSibling.nextElementSibling;

                for(let k = 0; k <= percent; k++) {
                    setTimeout(function() {
                        vchBarPercent[i].getElementsByTagName('span')[0].textContent = k;
                        progress.style.height = `${k}%`;
                        progressSib.style.height = `${k}%`;
                    }, k * 40);
                }
            }

            element.classList.add('vch-bar-chart');
        }
    });

    window.addEventListener('scroll', function() {
        let element = document.querySelector('.horizontal-charts-wrp');;
        let position = element.getBoundingClientRect();

        if(position.top >= 0 && position.bottom <= window.innerHeight && !element.classList.contains('hch-bar-chart')) {

            const vchBarPercent = document.querySelectorAll('.hch-bar-percent');

            for(let i = 0; i < vchBarPercent.length; i++) {
                let percent = vchBarPercent[i].getAttribute('data-percent');
                let progress = vchBarPercent[i].previousElementSibling;
                let progressSib = vchBarPercent[i].previousElementSibling.previousElementSibling;

                for(let k = 0; k <= percent; k++) {
                    setTimeout(function() {
                        vchBarPercent[i].getElementsByTagName('span')[0].textContent = k;
                        progress.style.width = `${k}%`;
                        progressSib.style.width = `${k}%`;
                    }, k * 40);
                }
            }

            element.classList.add('hch-bar-chart');
        }
    });

    //Close modal
    $('#modal').click(function () {
        $(this).removeClass('open');
    });
});

var MktoFormsEvent = null;
function showForm(id, page = '') {
    event.preventDefault()
    event.target.classList.add('disabled')
    MktoFormsEvent = event;
    MktoForms2.loadForm("//app-sj20.marketo.com", "375-JOE-551", 18710, function (form) {
        MktoForms2.lightbox(form).show();
        MktoFormsEvent.target.classList.remove('disabled');

        if ('finops' === page) {
            $('input[name="utm_campaign__c"]').val('2-2-1-HBRFinOpsPaper-DS-17-All_Seg-FY21-Q4-Global-OPC');
            $('input[name="utm_content__c"]').val('2-2-1-HBRFinOpsPaper-DS-17-All_Seg-FY21-Q4-Global-OPC');
            $('input[name="utm_medium__c"]').val('display');
            $('input[name="utm_source__c"]').val('hv_partner');
        } else if ('lumada' === page) {
            $('input[name="utm_campaign__c"]').val('2-3-2-451-DataOps-DS-14-All_Seg-FY21-Q4-Global-OPC');
            $('input[name="utm_content__c"]').val('blank');
            $('input[name="utm_medium__c"]').val('misc');
            $('input[name="utm_source__c"]').val('hv_partner');
        } else if ('everest' === page) {
            $('input[name="utm_campaign__c"]').val('Test Campaign');
            $('input[name="utm_content__c"]').val('Test Content');
            $('input[name="utm_medium__c"]').val('Test Medium');
            $('input[name="utm_source__c"]').val('Test Source');
        } else if ('index' === page) {
            $('input[name="utm_campaign__c"]').val('2-3-2-HBR-DataOps-DS-14-All_Seg-FY21-Q4-Global-OPC');
            $('input[name="utm_content__c"]').val('2-3-2-HBR-DataOps-DS-14-All_Seg-FY21-Q4-Global-OPC');
            $('input[name="utm_source__c"]').val('hv_partner');
        } else if ('forrester' === page) {
            $('input[name="utm_campaign__c"]').val('2-2-1-ForresterTEI-DS-17-All_Seg-FY21-Q4-Global-OPC');
            $('input[name="utm_medium__c"]').val('misc');
            $('input[name="utm_source__c"]').val('misc');
        }

        // Add an onSuccess handler
        form.onSuccess(function (values, followUpUrl) {
            // Get the form's jQuery element and hide it
            form.getFormElem().hide();

            if (buttons[id].download) {
                //Create XMLHTTP Request.
                var req = new XMLHttpRequest();
                req.open("GET", buttons[id].link, true);
                req.responseType = "blob";
                req.onload = function () {
                    //Convert the Byte Data to BLOB object.
                    var blob = new Blob([req.response], {type: "application/octetstream"});

                    //Check the Browser type and download the File.
                    var isIE = false || !!document.documentMode;
                    if (isIE) {
                        window.navigator.msSaveBlob(blob, id);
                    } else {
                        var url = window.URL || window.webkitURL;
                        var link = url.createObjectURL(blob);
                        var a = document.createElement("a");
                        a.setAttribute("download", id);
                        a.setAttribute("href", link);
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }
                };
                req.send();
            } else {
                window.open(buttons[id].link, buttons[id].target).focus();
            }

            return false;
        });
    });
}

function showModal(id = 'modal', sub_id = null) {
    event.preventDefault();
    document.getElementById(id).classList.add('open');
    if (null !== sub_id) {
        document.getElementById(sub_id).classList.add('open');
    }
}
function closeModal(id = 'modal') {
    event.preventDefault();
    document.getElementById(id).classList.remove('open');
    document.getElementById(id).querySelector('.modal-sub-content.open').classList.remove('open');
}
